module.exports = __webpack_public_path__ + "img/8.df5fd724.jpg";